import { mdiHistory } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/shared/logic/administration"
import type { OrgaViewFrameContext } from "../../../../context"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "audit",
  title: "Protokoll",
  tooltip:
    "Nachvollziehen, wer wann welche Änderungen und Aktionen in der Organisation ausgeführt hat.",
  icon: mdiHistory,
  routeSegment: "audit",
  getPages: (context) =>
    context.permissions.allows("core.audit_log", "view")
      ? [
          {
            id: "audit",
            title: "Protokoll",
            path: "",
            widthType: "normal",
            testId: "controlAdmin.organizationView.tab.audit",
          },
        ]
      : [],
}
